import ArrowTopRight from "@components/icons/arrow-top-right";
import Download from "@components/icons/download";
import ListItem from "@components/list-item";
import * as React from "react";
import { create } from "zustand";
import ModalTitle from "@components/modal-title";
import ClosableModal from "@components/closable-modal/closable-modal";
import ModalPadding from "@components/closable-modal/modal-padding";
import { Text } from "dripsy";

const usePromptInstall = create<any>(() => ({
  event: null as any,
}));

window.addEventListener("beforeinstallprompt", (event) => {
  usePromptInstall.setState({ event });
});

function InstallPWA() {
  const [modalVisible, setModalVisible] = React.useState(false);
  const promptInstall = usePromptInstall((state: any) => state.event);

  const isInStandaloneMode = () =>
    window.matchMedia("(display-mode: standalone)").matches ||
    (window as any).navigator.standalone ||
    document.referrer.includes("android-app://");

  const supportsPWA = "serviceWorker" in navigator;

  const onClick = () => {
    if (!promptInstall) {
      setModalVisible(true);
      return;
    }
    promptInstall.prompt();
  };

  if (!supportsPWA || isInStandaloneMode()) {
    return null;
  }

  return (
    <>
      <ListItem
        onPress={onClick}
        title="Installeer de webapp"
        description="Gemakkelijk toegang vanaf Start of Spotlight"
        left={<Download size={20} color="$text" />}
      />
      <ClosableModal
        isVisible={modalVisible}
        onRequestClose={() => {
          setModalVisible(false);
        }}
      >
        <ModalTitle title="Al geïnstalleerd" />
        <ModalPadding>
          <Text>
            Deze app is al geïnstalleerd, zoek via Start of Spotlight naar De Grote Verleiding.{"\n"}Of druk op het{" "}
            <ArrowTopRight size={20} color="$text" /> icoon in de adresbalk.
          </Text>
        </ModalPadding>
      </ClosableModal>
    </>
  );
}

export default InstallPWA;
